import { render, staticRenderFns } from "./StudentAssignmentDetail.vue?vue&type=template&id=5602e3d0&scoped=true"
import script from "./StudentAssignmentDetail.vue?vue&type=script&lang=js"
export * from "./StudentAssignmentDetail.vue?vue&type=script&lang=js"
import style0 from "./StudentAssignmentDetail.vue?vue&type=style&index=0&id=5602e3d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5602e3d0",
  null
  
)

export default component.exports